export default __webpack_public_path__ + "static/media/es-ct.98b46c8f.svg";